import { Component, OnInit, Input } from '@angular/core';
import { HttpService } from 'src/app/services/http.service';
import { Router } from '@angular/router';
import { WploginService } from 'src/app/services/wplogin.service';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-doctyp6',
  templateUrl: './doctyp6.component.html',
  styleUrls: ['./doctyp6.component.scss']
})
export class Doctyp6Component implements OnInit {

  @Input() Document: any;
  wellen = [];
  tests = [];
  probanden = [];
  Doi: any;
  pdf: string;
  access = false;


  constructor(
    private http: HttpService,
    private router: Router,
    private wplogin: WploginService,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit() {

    this.access = this.wplogin.getLoginStatus();
    console.log(this.access);

    if (this.Document['6_vw_gen_wellen'] && this.Document['6_vw_gen_wellen'] !== undefined ) {
      this.Document['6_vw_gen_wellen'].forEach(element => {
        if (element['ID']) {

          this.http.analyse(element['ID']).subscribe(analyse => {
            this.wellen.push(analyse);
        });
      }
      });
     }

     if (this.Document['6_vw_gen_tests'] && this.Document['6_vw_gen_tests'] !== undefined ) {
      this.Document['6_vw_gen_tests'].forEach(element => {
            if (element['ID']) {

                this.http.analyse(element['ID']).subscribe(analyse => {
                  this.tests.push(analyse);
              });
            }
      });
     }

     this.Doi = this.Document['6_vw_doi_link'].replace('http://dx.doi.org/', '');


     if (this.Document['6_vw_gen_probanden'] && this.Document['6_vw_gen_probanden'] !== undefined ) {
      this.Document['6_vw_gen_probanden'].forEach(element => {
            if (element['ID']) {

                this.http.analyse(element['ID']).subscribe(analyse => {
                  this.probanden.push(analyse);
              });
            }
      });
     }



     if (this.Document['6_sourcename0']) {
      this.pdf = 'https://bolsa.uni-halle.de/wp-content/themes/graphy/app/assets/anhang/' + this.Document['6_sourcename0'];
     }


     const cit = this.Document['6_vw_id_in_index'];



  }


  link(id) {
    this.router.navigateByUrl('/' , {skipLocationChange: true}).then(() =>
    this.router.navigate(['/document/' + id]));
  }



  copy2Clipboard() {
    const element = document.getElementById('copy-cit');
    element.innerHTML = element.innerText || element.textContent;

    const ta = document.createElement('textarea');
    ta.value = element.innerHTML;
    document.body.appendChild(ta);
    ta.select();
    document.execCommand('copy');
    document.body.removeChild(ta);

    this.snackBar.open('In die Zwischenablage kopiert', 'schließen', {
      duration: 2000,
    });
  }


}
